export default "__VITE_ASSET__c0af0f99__"